import { useMemo } from 'react';

const GINGHAM_CLASSES = [
  'gingham-btn-1', // gingham2
  'gingham-btn-2', // polkadots
  'gingham-btn-4', // gingham9
];

// Returns a stable random gingham class for a given key (or pure random if no key)
export function useGinghamClass(key) {
  return useMemo(() => {
    const idx = key != null
      ? Math.abs(String(key).split('').reduce((a, c) => a + c.charCodeAt(0), 0)) % GINGHAM_CLASSES.length
      : Math.floor(Math.random() * GINGHAM_CLASSES.length);
    return GINGHAM_CLASSES[idx];
  }, [key]);
}

// For use outside hooks (e.g. mapping arrays)
export function getGinghamClass(key) {
  const idx = key != null
    ? Math.abs(String(key).split('').reduce((a, c) => a + c.charCodeAt(0), 0)) % GINGHAM_CLASSES.length
    : Math.floor(Math.random() * GINGHAM_CLASSES.length);
  return GINGHAM_CLASSES[idx];
}
